import { render, staticRenderFns } from "./liveFile.vue?vue&type=template&id=8554ca42&scoped=true&"
import script from "./liveFile.vue?vue&type=script&lang=js&"
export * from "./liveFile.vue?vue&type=script&lang=js&"
import style0 from "./liveFile.vue?vue&type=style&index=0&id=8554ca42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8554ca42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8554ca42')) {
      api.createRecord('8554ca42', component.options)
    } else {
      api.reload('8554ca42', component.options)
    }
    module.hot.accept("./liveFile.vue?vue&type=template&id=8554ca42&scoped=true&", function () {
      api.rerender('8554ca42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityAccount/poolPop/liveFile.vue"
export default component.exports